export const SuperUser = [{
  path: 'superuser',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'SuperUser',
      component: () => import('../../../components/Admin/SuperUser'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'create',
      name: 'SuperUserCreate',
      component: () => import('../../../components/Admin/SuperUser/create'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'edit/:id',
      name: 'SuperUserEdit',
      component: () => import('../../../components/Admin/SuperUser/edit'),
      meta: {
        access: ['admin']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/admin/module/superUser.js